import React, { useCallback, useEffect, useRef, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import ToggleButton from "components/common/togglebutton";
import {
  OrganizationInitialValues,
  OrganizationAddSchema,
  KeyContactInitialValues,
  formatPhoneNumber,
} from "constants/community";
import Input from "components/common/input";
import SelectComponent from "components/common/select";
import { CaretRight, CaretDown, Trash } from "phosphor-react";
import { v4 as uuidv4 } from "uuid";
import Collapse from "react-bootstrap/Collapse";
import RadioButton from "components/common/radio-button/RadioButton";
import Accordion from "react-bootstrap/Accordion";
import {
  normalizeInput,
  ORGANIZATION_TYPES,
  US_STATES,
} from "constants/common";
import { getCities, getCounties, getStates } from "containers/policies/api";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import debounce from "lodash/debounce";
import { result } from "lodash";
import {
  useDebouncedCitiesDataCallback,
  useDebouncedCountiesDataCallback,
  useDebouncedStatesDataCallback,
  useDebouncedZipCodesDataCallback,
} from "utils/debouncedHelper";
import { getZipCodes } from "containers/leadcaremanager/api";
import { capitalizeName, formatLocation } from "utils/common";

const AddOrganizationForm = ({
  handleSubmittion,
  handleClose,
  currentOrganizationEdit,
}) => {
  const [forceUpdate, setForceUpdate] = useState(false);
  const isEditMode = Boolean(currentOrganizationEdit);
  const [countiesList, setCountiesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [zipCodesList, setZipCodesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const debouncedCoutiesDataCallback = useDebouncedCountiesDataCallback();
  const debouncedStatesDataCallback = useDebouncedStatesDataCallback();
  const debouncedCitiesDataCallback = useDebouncedCitiesDataCallback();
  const debouncedZipCodesDataCallback = useDebouncedZipCodesDataCallback();
  const [activeKey, setActiveKey] = useState(null);
  const fetchStates = async () => {
    const result = await getStates({
      ...initialMetaForTable,
    });
    if (result["states"]) {
      const data = result?.states;
      setStateList(data);
    }
  };
  const fetchZipCodes = async (stateId, countyId, cityId) => {
    const result = await getZipCodes({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
      city_id: cityId,
    });
    if (result["zip_codes"]) {
      const data = result?.zip_codes;
      setZipCodesList(data);
    }
  };

  const fetchCounties = async (stateId) => {
    const result = await getCounties({
      ...initialMetaForTable,
      state_id: stateId,
    });
    if (result["counties"]) {
      const data = result?.counties;
      setCountiesList(data);
    }
  };

  const fetchCities = async (stateId, countyId) => {
    const result = await getCities({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
    });
    if (result["cities"]) {
      const data = result?.cities;
      setCitiesList(data);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    if (currentOrganizationEdit?.address?.state) {
      fetchCounties(currentOrganizationEdit?.address?.state_id);
    }
  }, [currentOrganizationEdit]);
  useEffect(() => {
    if (
      currentOrganizationEdit?.address?.state &&
      currentOrganizationEdit?.address?.county
    ) {
      fetchCities(
        currentOrganizationEdit?.address?.state_id,
        currentOrganizationEdit?.address?.county_id
      );
    }
  }, [currentOrganizationEdit]);
  useEffect(() => {
    if (
      currentOrganizationEdit?.address?.state &&
      currentOrganizationEdit?.address?.county &&
      currentOrganizationEdit?.address?.city
    ) {
      fetchZipCodes(
        currentOrganizationEdit?.address?.state_id,
        currentOrganizationEdit?.address?.county_id,
        currentOrganizationEdit?.address?.city_id
      );
    }
  }, [currentOrganizationEdit]);
  return (
    <Formik
      initialValues={
        isEditMode
          ? {
              ...OrganizationInitialValues,
              ...currentOrganizationEdit,
              organization_contacts_attributes:
                currentOrganizationEdit.organization_contacts,
              address_attributes:
                currentOrganizationEdit.address ||
                OrganizationInitialValues.address_attributes,
              // county_id: currentOrganizationEdit?.address?.county_id || "",
              county: currentOrganizationEdit?.address?.county || "",
              city: currentOrganizationEdit?.address?.city || "",
              state: currentOrganizationEdit?.address?.state || "",
              zip_code: currentOrganizationEdit?.address?.zip_code || "",
              city_id: currentOrganizationEdit?.address?.city_id || "",
              county_id: currentOrganizationEdit?.address?.county_id || "",
              state_id: currentOrganizationEdit?.address?.state_id || "",
              zip_code_id: currentOrganizationEdit?.address?.zip_code_id || "",
            }
          : OrganizationInitialValues
      }
      validationSchema={OrganizationAddSchema}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        handleSubmittion(values, setSubmitting, setErrors);
      }}
    >
      {({
        handleChange,
        values,
        errors,
        handleSubmit,
        setFieldValue,
        isSubmitting,
        setValues,
        setFieldTouched,
      }) => {
        console.log(values);
        return (
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />
            <form className="form-main" onSubmit={handleSubmit}>
              <div className="input-flex row">
                <ToggleButton
                  label="Status"
                  handleChange={(name, value) => {
                    setFieldValue(
                      name,
                      !!Number(value) ? "active" : "inactive"
                    );
                  }}
                  value={values?.status === "active" ? 1 : 0}
                  name="status"
                  // disabled={currentQuestionEdit ? true : false}
                />
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. Bay Area Housing Support"
                    type="text"
                    label="Name"
                    isRequired
                    value={values.name}
                    name="name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="name"
                      />
                    }
                  />
                </div>

                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. John Doe"
                    type="text"
                    label="Parent Company"
                    isRequired
                    value={values.owner}
                    name="owner"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="owner"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. info@ifhomeless.org"
                    type="email"
                    label="Email"
                    isRequired
                    value={values.email}
                    name="email"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="email"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={(e) => {
                      const formattedNumber = normalizeInput(e.target.value);
                      setFieldValue("phone", formattedNumber);
                    }}
                    placeholder="e.g. 555-123-4567"
                    type="text"
                    label="Phone"
                    value={values.phone}
                    name="phone"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="phone"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. www.ifhomeless.org"
                    type="text"
                    label="Website"
                    value={values.website}
                    name="website"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="website"
                      />
                    }
                  />
                </div>

                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. 1234 Main St."
                    type="text"
                    label="Address"
                    isRequired
                    value={values.address_attributes.street}
                    name="address_attributes.street"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.street"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <AsyncSelect
                    label="State"
                    isRequired
                    options={
                      stateList.find(
                        (plan) => plan.id === currentOrganizationEdit?.state
                      ) || typeof currentOrganizationEdit?.state == "undefined"
                        ? [
                            ...stateList?.map((el) => {
                              return {
                                value: el.id,
                                label: el.name.toUpperCase(),
                              };
                            }),
                          ]
                        : [
                            ...stateList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: currentOrganizationEdit.state.id,
                              label: currentOrganizationEdit.state?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedStatesDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={
                      values?.address_attributes?.state
                        ? {
                            value: values.address_attributes.state_id,
                            label: values.address_attributes.state,
                          }
                        : null
                    }
                    handleChange={(obj) => {
                      setFieldValue("address_attributes.state", obj.label);
                      setFieldValue("address_attributes.state_id", obj.value);
                      setFieldValue("address_attributes.county", "");
                      setFieldValue("address_attributes.county_id", "");
                      setFieldValue("address_attributes.city", "");
                      setFieldValue("address_attributes.city_id", "");
                      setFieldValue("address_attributes.zip_code", "");
                      setFieldValue("address_attributes.zip_code_id", "");
                      fetchCounties(obj.value);
                    }}
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.state"
                      />
                    }
                    name="address_attributes.state"
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="County"
                    disabled={values?.address_attributes?.state ? false : true}
                    options={
                      countiesList.find(
                        (plan) => plan.id === currentOrganizationEdit.county_id
                      ) ||
                      typeof currentOrganizationEdit.county_id == "undefined"
                        ? [
                            ...countiesList?.map((el) => {
                              return {
                                value: el.id,
                                label: formatLocation(el.name),
                              };
                            }),
                          ]
                        : [
                            ...countiesList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: currentOrganizationEdit.county_id,
                              label: currentOrganizationEdit.county,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCoutiesDataCallback(
                          inputValue,
                          values?.address_attributes?.state_id,
                          resolve
                        );
                      })
                    }
                    selectedValue={
                      values?.address_attributes?.county
                        ? {
                            value: values.address_attributes.county_id,
                            label: values.address_attributes.county,
                          }
                        : null
                    }
                    placeholder="e.g Los Angles"
                    handleChange={(obj) => {
                      // setFieldValue("address_attributes.county_ids", obj.value);
                      setFieldValue("address_attributes.county", obj.label);
                      setFieldValue("address_attributes.county_id", obj.value);
                      setFieldValue("address_attributes.city", "");
                      setFieldValue("address_attributes.city_id", "");
                      setFieldValue("address_attributes.zip_code", "");
                      setFieldValue("address_attributes.zip_code_id", "");
                      fetchCities(
                        values?.address_attributes?.state_id,
                        obj.value
                      );
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.county"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="City"
                    // isRequired
                    disabled={values?.address_attributes?.county ? false : true}
                    options={citiesList.map((el) => ({
                      value: el.id,
                      label: capitalizeName(el.name),
                    }))}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCitiesDataCallback(
                          inputValue,
                          values?.address_attributes?.state_id,
                          values?.address_attributes?.county_id,
                          resolve
                        );
                      })
                    }
                    name={"address_attributes.city"}
                    selectedValue={
                      values?.address_attributes?.city
                        ? {
                            value: values.address_attributes.city_id,
                            label: values.address_attributes.city,
                          }
                        : null
                    }
                    placeholder="Select City"
                    handleChange={(obj) => {
                      setFieldValue("address_attributes.city", obj.label);
                      setFieldValue("address_attributes.city_id", obj.value);
                      setFieldValue("address_attributes.zip_code_id", "");
                      setFieldValue("address_attributes.zip_code", "");
                      fetchZipCodes(
                        values?.address_attributes?.state_id,
                        values?.address_attributes?.county_id,
                        values?.address_attributes?.city_id,
                        obj.value
                      );
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.city"
                      />
                    }
                  />
                </div>
                {/* <div className="col-sm-6">
                  <Input
                    handleChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      if (value.length > 5) {
                        value = value.slice(0, 5) + "-" + value.slice(5, 9);
                      }
                      setFieldValue("address_attributes.zip_code", value);
                    }}
                    placeholder="e.g. 94103"
                    type="text"
                    label="ZIP Code"
                    isRequired
                    value={values.address_attributes.zip_code}
                    name="address_attributes.zip_code"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.zip_code"
                      />
                    }
                  />
                </div> */}

                <div className="col-sm-6">
                  <AsyncSelect
                    name="address_attributes.zip_code"
                    label="ZIP Code"
                    disabled={values?.address_attributes?.city ? false : true}
                    options={
                      zipCodesList.find(
                        (plan) => plan.id === currentOrganizationEdit?.zip_code
                      ) ||
                      typeof currentOrganizationEdit?.zip_code == "undefined"
                        ? [
                            ...zipCodesList?.map((el) => {
                              return {
                                value: el.id,
                                label: el.code,
                              };
                            }),
                          ]
                        : [
                            ...zipCodesList?.map((el) => {
                              return { value: el.id, label: el.code };
                            }),
                            {
                              value: currentOrganizationEdit.zip_code?.id,
                              label: currentOrganizationEdit.zip_code?.code,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedZipCodesDataCallback(
                          inputValue,
                          values?.address_attributes?.state_id,
                          values?.address_attributes?.county_id,
                          values?.address_attributes?.city_id,

                          resolve
                        );
                      })
                    }
                    selectedValue={
                      values?.address_attributes?.zip_code
                        ? {
                            value: values.address_attributes.zip_code_id,
                            label: values.address_attributes.zip_code,
                          }
                        : null
                    }
                    handleChange={(obj) => {
                      setFieldValue("address_attributes.zip_code", obj.label);
                      setFieldValue(
                        "address_attributes.zip_code_id",
                        obj.value
                      );
                    }}
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="address_attributes.zip_code"
                      />
                    }
                  />
                </div>

                <div>
                  <SelectComponent
                    label="Organization Type"
                    isRequired
                    options={ORGANIZATION_TYPES}
                    selectedValue={values?.organization_type}
                    handleChange={(obj) => {
                      setFieldValue("organization_type", obj.value);
                    }}
                    placeholder="Select Organization Type"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="organization_type"
                      />
                    }
                    name="organization_type"
                  />
                </div>
              </div>
              <h6 className="fw-bold my-3">
                Key Contacts{" "}
                {<span style={{ color: "red", fontWeight: "300" }}>*</span>}
              </h6>
              {errors.organization_contacts_attributes &&
              typeof errors.organization_contacts_attributes === "string" ? (
                <p className=" text-danger">
                  {errors.organization_contacts_attributes}
                </p>
              ) : (
                <p className=" text-danger">
                  {errors.organization_contacts_attributes?.length
                    ? "Fill this section"
                    : ""}
                </p>
              )}
              <Accordion
                activeKey={activeKey}
                onSelect={(key) => setActiveKey(key)}
              >
                {values.organization_contacts_attributes.map((contact, index) =>
                  contact._destroy !== true ? (
                    <Accordion.Item
                      eventKey={(contact.id || index).toString()}
                      key={contact.id || index}
                    >
                      <Accordion.Header>
                        <div className="card-header d-flex justify-content-between align-items-center w-100">
                          <div>
                            <p className="m-0 fw-bold">
                              Contact{" "}
                              {values.organization_contacts_attributes
                                .filter((c) => !c._destroy)
                                .indexOf(contact) + 1}
                            </p>
                          </div>
                          <div className=" d-flex justify-content-end align-items-center gap-4 pe-4">
                            <RadioButton
                              // id={`organization_contacts_attributes[${index}].primary`}
                              // name={`organization_contacts_attributes[${index}].primary`}
                              value={
                                values.organization_contacts_attributes[index]
                                  .primary
                              }
                              text={"Make Primary"}
                              onChange={(e) => {
                                const prevPrimaryIndex = values.organization_contacts_attributes.findIndex(
                                  (contact) => contact.primary
                                );

                                if (prevPrimaryIndex > -1) {
                                  setFieldValue(
                                    `organization_contacts_attributes[${prevPrimaryIndex}].primary`,
                                    false
                                  );
                                }
                                setFieldValue(
                                  `organization_contacts_attributes[${index}].primary`,
                                  true
                                );
                              }}
                              checked={
                                values.organization_contacts_attributes[index]
                                  .primary
                              }
                              className="d-flex justify-content-end align-items-center mb-3"
                            />
                            <button
                              type="button"
                              className={`border-0 bg-transparent ${
                                values.organization_contacts_attributes[index]
                                  ?.primary
                                  ? "opacity-60 disabled"
                                  : "opacity-100"
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  !values.organization_contacts_attributes[
                                    index
                                  ]?.primary
                                ) {
                                  setFieldValue(
                                    `organization_contacts_attributes[${index}]._destroy`,
                                    true
                                  );
                                  setForceUpdate((prev) => !prev);
                                }
                              }}
                              disabled={
                                values.organization_contacts_attributes[index]
                                  ?.primary
                              }
                            >
                              <Trash size={20} />
                            </button>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="card card-body  bg-secondary-subtle rounded-3  ">
                          <div className="input-flex row justify-content-around">
                            <div className="col-sm-5">
                              <Input
                                handleChange={handleChange}
                                placeholder="e.g. John Doe"
                                type="text"
                                label="Name"
                                isRequired
                                value={
                                  values.organization_contacts_attributes[index]
                                    .name
                                }
                                name={`organization_contacts_attributes[${index}].name`}
                                error={
                                  <ErrorMessage
                                    className="error-message"
                                    component="p"
                                    name={`organization_contacts_attributes[${index}].name`}
                                  />
                                }
                              />
                            </div>

                            <div className="col-sm-5">
                              <Input
                                handleChange={handleChange}
                                placeholder="e.g. Program Coordinator"
                                type="text"
                                label="Designation"
                                value={
                                  values.organization_contacts_attributes[index]
                                    .designation
                                }
                                name={`organization_contacts_attributes[${index}].designation`}
                                className="mb-1"
                                error={
                                  <ErrorMessage
                                    className="error-message"
                                    component="p"
                                    name={`organization_contacts_attributes[${index}].designation`}
                                  />
                                }
                              />
                            </div>
                          </div>
                          <div className="input-flex row justify-content-around">
                            <div className="col-sm-5">
                              <Input
                                handleChange={handleChange}
                                placeholder="e.g. info@ifhomeless.org"
                                type="email"
                                label="Email"
                                isRequired
                                value={
                                  values.organization_contacts_attributes[index]
                                    .email
                                }
                                name={`organization_contacts_attributes[${index}].email`}
                                error={
                                  <ErrorMessage
                                    className="error-message"
                                    component="p"
                                    name={`organization_contacts_attributes[${index}].email`}
                                  />
                                }
                              />
                            </div>
                            <div className="col-sm-5">
                              <Input
                                handleChange={(e) => {
                                  let formattedNumber = normalizeInput(
                                    e.target.value
                                  );
                                  setFieldValue(
                                    `organization_contacts_attributes[${index}].phone`,
                                    formattedNumber
                                  );
                                }}
                                placeholder="e.g. (555) 123-4567"
                                type="text"
                                label="Phone"
                                value={
                                  values.organization_contacts_attributes[index]
                                    .phone
                                }
                                name={`organization_contacts_attributes[${index}].phone`}
                                error={
                                  <ErrorMessage
                                    className="error-message"
                                    component="p"
                                    name={`organization_contacts_attributes[${index}].phone`}
                                  />
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ) : null
                )}
              </Accordion>
              <div className="action gap-2">
                <button
                  className="secondary-btn w-100"
                  type="button"
                  onClick={() =>
                    setFieldValue("organization_contacts_attributes", [
                      ...values.organization_contacts_attributes,
                      { ...KeyContactInitialValues },
                    ])
                  }
                >
                  + Add More
                </button>
              </div>
              <hr className="custom-modal-line mt-4" />
              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <>
                    <span className="primary-btn w-50">
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </span>
                  </>
                ) : (
                  <input
                    className="primary-btn w-50"
                    type="submit"
                    name="submit"
                    value={isEditMode ? "Save Changes" : "Add Organization"}
                  />
                )}
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddOrganizationForm;
